//@ts-expect-error Library not migrated yet
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H7 } from 'foundations-components/transitional/components/H7';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const HubspotPlaylistProfessors = ({
  professors
}) => {
  if (!professors.length) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(H7, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.instructors"
      }), ":"]
    }), /*#__PURE__*/_jsx(UIAvatar, {
      lookup: professors.map(professor => {
        return {
          displayName: professor.name,
          src: professor.image,
          type: 'contact'
        };
      }),
      maxAvatars: 5
    })]
  });
};
export default HubspotPlaylistProfessors;